// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__zmwtb","Cell":"EmployeeTable_Cell__QkTvJ","Paper":"EmployeeTable_Paper__1s7Dl"};